<template>
  <PrimeDatePicker
    v-model="parsedDate"
    class="w-full"
    @update:modelValue="changeEventHandler($event)"
    @blur="blurEventHandler($event)"
    v-bind="$attrs"
    :disabled="loading || disabled"
    :showIcon="true"
    :invalid="hasErrors"
    :id="props.id"
    :placeholder="props.placeholder"
    :minDate="props.min"
    :maxDate="props.max"
    mask="99/99/9999"
    dateFormat="dd/mm/yy"
  >
    <template #footer>
      <div class="flex flex-row items-center justify-center w-full gap-2">
        <PrimeButton
          label="Today"
          icon="pi pi-calendar-clock"
          @click="
            () => {
              parsedDate = new Date();
            }
          "
        />
        <PrimeButton
          label="Clear"
          icon="pi pi-times"
          severity="secondary"
          @click="
            () => {
              parsedDate = undefined;
            }
          "
        />
      </div>
    </template>
  </PrimeDatePicker>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: string;
    loading?: boolean;
    id?: string;
    placeholder?: string;
    min?: Date;
    max?: Date;
    context?: Indexable;
  }>(),
  {
    disabled: false,
    context: () => ({}),
    loading: false,
  }
);

//console.log('dateSelect:', props);

const value = defineModel<any>("value");
const values = defineModel<any>("values");

watch(
  values,
  (newValue) => {
    //console.log('values changed:', newValue)
    value.value = newValue;
    changeEventHandler({ value: newValue });
  },
  {
    deep: true,
  }
);

// Computed property to handle date parsing
const parsedDate = computed({
  get() {
    //console.log('getting value.value', value.value, dayjs(value.value).isValid())
    return value.value && dayjs(value.value).isValid()
      ? dayjs(value.value).toDate()
      : undefined;
  },
  set(newDate) {
    //console.log('setting value.value', newDate, `with type: ${typeof(newDate)}`)
    value.value = newDate ? dayjs(newDate).format("YYYY-MM-DD") : null;
  },
});

const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

function changeEventHandler($event: any) {
  //console.log('value changed:', $event)
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
